export default __webpack_public_path__ + "static/media/B0004.9e240369.png";